<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Dicas Técnicas</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="subCategoryProducts">Dicas Técnicas</label>
                                    <select name="subCategoryProducts[]" id="subCategoryProducts" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(subCategoryProduct, index) in subCategoryProducts">
                                            {{ subCategoryProduct.description }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setSubCategoryProducts">Ordenar Dicas Técnicas <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(subCategoryProduct,index) in selected' :key="subCategoryProduct.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + subCategoryProduct.id">{{ index + 1 }}. {{ subCategoryProduct.description }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(subCategoryProduct, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                subCategoryProducts: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getSubCategoryProductsArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getSubCategoryProducts: function(){
                let self = this;
                let api  = self.$store.state.api + 'subCategoryProduct?paginated=false';
                let subCategoryProducts = $('#subCategoryProducts');

                self.$http.get(api)
                    .then((response) => {
                        self.subCategoryProducts = response.data.data;
                        self.ordered  = self.getSubCategoryProductsArray(self.subCategoryProducts);
                    })
                    .then(() => {
                        subCategoryProducts.bootstrapDualListbox();
                        subCategoryProducts.ready(function () {
                            subCategoryProducts.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os SubCategoryProducts', 'error');
                    });
            },
            setSubCategoryProducts: function(){
                const self   = this;
                let subCategoryProducts = self.selected;

                $('#subCategoryProducts').find(':selected').each(function(){
                    subCategoryProducts.push(self.subCategoryProducts[$(this).val()]);
                });

                self.selected = subCategoryProducts;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/subCategoryProduct", self.getSubCategoryProductsArray);
            },
            remove: function(subCategoryProduct, index){
                const self = this;
                const api  = self.$store.state.api + 'subCategoryProduct/' + subCategoryProduct.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getSubCategoryProducts();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SubCategoryProductOrder/Index.vue